import { getUserState } from 'stores';

// Non-component export separated for Vite Fast Refresh compatibility
export const getMenuRoutes = isLive => {
  try {
    const loggedInUser = getUserState().user || {};

    // Ensure user permissions exist with defaults
    const safeUser = {
      ...loggedInUser,
      show_producer_tools: loggedInUser.show_producer_tools || false,
      show_moderation_tools: loggedInUser.show_moderation_tools || false,
      show_programming_tools: loggedInUser.show_programming_tools || false,
      show_developer_tools: loggedInUser.show_developer_tools || false,
      can_manage_org: loggedInUser.can_manage_org || false,
    };

    const isBroadcastPage =
      window.location.href.indexOf('/broadcast/') > 0 && window.location.href.indexOf('/broadcast/my') < 0;
    const domain = new URL(window.location.href).origin;

    let routes;
    if (isBroadcastPage) {
      routes = {
        path: '/',
        routes: [
          {
            key: 'dashboard',
            path: `/broadcast/my`,
            name: 'Dashboard',
            target: '_blank',
          },
        ],
      };
    } else {
      routes = {
        path: '/',
        routes: [
          {
            key: 'dashboard',
            path: `/broadcast/my`,
            name: 'Dashboard',
          },
          {
            key: 'graphics',
            path: '/media',
            name: 'Graphics',
            hideInMenu: isBroadcastPage,
          },
          {
            key: 'communities',
            path: '/communities',
            name: 'Communities',
            hideInMenu: true,
          },
          {
            key: 'producers',
            name: 'Producers',
            hideInMenu: !safeUser.show_producer_tools && !safeUser.show_moderation_tools,
            children: [
              {
                key: 'active-events',
                path: `${domain}/event/active`,
                name: 'Stream Manager',
                target: '_self',
              },
              {
                key: 'video-notes',
                path: `${domain}/notes`,
                name: 'Video Notes',
                hideInMenu: !safeUser.show_producer_tools,
                target: '_self',
              },
              {
                key: 'moderation',
                path: `${domain}/moderation`,
                name: 'Moderation',
                hideInMenu: !safeUser.show_moderation_tools,
                target: '_self',
              },
            ],
          },
          {
            key: 'programmers',
            name: 'Programmers',
            hideInMenu: !safeUser.show_programming_tools,
            children: [
              {
                key: 'live-programming',
                path: `${domain}/event/active?programmingType=streamSlicer`,
                name: 'StreamSlicer',
                target: '_self',
              },
              {
                key: 'clips',
                path: `${domain}/allclips`,
                name: 'Clip Manager',
                target: '_self',
              },
            ],
          },
          {
            key: 'developers',
            name: 'Developers',
            hideInMenu: !safeUser.show_developer_tools,
            children: [
              {
                key: 'webhooks',
                path: `${domain}/webhooks`,
                name: 'Webhooks',
              },
              {
                key: 'overlay-editor',
                path: `${domain}/overlay-editor`,
                name: 'Overlay Editor',
              },
              // {
              //   key: "web-embed",
              //   path: `${domain}/web-embed`,
              //   name: "Web Embed"          },
              {
                key: 'api-docs',
                path: 'https://docs.hotmic.io/api',
                name: 'API Documentation',
                target: '_blank',
              },
            ],
          },
          {
            key: 'admins',
            name: 'Admins',
            hideInMenu: !safeUser.can_manage_org,
            children: [
              {
                key: 'users',
                path: `${domain}/user/list`,
                name: 'Users',
                target: '_self',
              },
              {
                key: 'notifications',
                path: `${domain}/notifications/admin`,
                name: 'Alerts',
                target: '_self',
              },
              {
                key: 'rules',
                path: `${domain}/rules`,
                name: 'Rules',
                target: isBroadcastPage && isLive ? '_blank' : '_self',
              },
              {
                key: 'usage',
                path: `${domain}/usage`,
                name: 'Usage',
                target: '_self',
              },
            ],
          },
          {
            key: 'help',
            path: 'https://brcreators.zendesk.com/hc/en-us',
            name: 'Help',
            target: '_blank',
          },
          {
            key: 'settings',
            path: '/settings/:name',
            name: 'Settings',
            hideInMenu: true,
          },
        ],
      };
    }

    return routes;
  } catch (error) {
    // Return a minimal routes object as fallback
    return {
      path: '/',
      routes: [
        {
          key: 'dashboard',
          path: `/broadcast/my`,
          name: 'Dashboard',
        },
        {
          key: 'help',
          path: 'https://brcreators.zendesk.com/hc/en-us',
          name: 'Help',
          target: '_blank',
        },
      ],
    };
  }
};
